export default __webpack_public_path__ + "static/media/feets_sand.03311cf1.jpg";